// Bump VIDEO_VERSION whenever the walkthrough files are re-rendered so browsers/CDN fetch the new copy.
export const VIDEO_VERSION = "20261013a";
export const VIDEO = {
  mp4: `/videos/walkthrough.mp4?v=${VIDEO_VERSION}`,
  vertical: `/videos/walkthrough-vertical.mp4?v=${VIDEO_VERSION}`,
  poster: `/videos/walkthrough-poster.jpg?v=${VIDEO_VERSION}`,
  portrait: true,
};
